import { render, staticRenderFns } from "./SuitcaseForm.vue?vue&type=template&id=5690a17f&scoped=true"
import script from "./SuitcaseForm.vue?vue&type=script&lang=js"
export * from "./SuitcaseForm.vue?vue&type=script&lang=js"
import style0 from "./SuitcaseForm.vue?vue&type=style&index=0&id=5690a17f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5690a17f",
  null
  
)

export default component.exports